export const QA_NAME_ACCORDION_SECTION_CONTEXT = 'section'
